const messages = {
  title: "Bonusmultiplikator",
  bandBonusTitle: "Bonus per dekk ved multiplikator",
  amountLabel: "Min. antall dekk (*)",
  label: "Bonusmultiplikator",
  desc: "Antall Bridgestone- og Firestone-dekk. Det gis ikke bonus i euro på Firestone-dekk.",
  goals: {
    loyal: "Lojal",
    bronze: "Bronse",
    silver: "Sølv",
    gold: "Gull",
    platinum: "Platina",
  },
  andMore: "og mer",
  chooseTarget: "Velg",
  selectTarget: "Velg ditt årlige mål for {year} her:",
  multiplication: "Bonus multipliseres med <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} dekk",
};

export default {
  messages,
};
